import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* REST API */
import { history } from "../../api/Profile"

/* Widgets */
import { Layout } from "../Table"

/* Components */
import { Pagination } from "../../components"

/* Icons */
import { CloseIcon, ClockIcon, MonitorIcon, PhoneIcon, PinIcon } from "../../components/Icons"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"


/* THE STATE OF A CLOSED PANEL */
const EMPTY = {
    status: "loading",
    data: [],
    count: 0,
    page: 1,
}

/* THE SIZE OF A PAGE — THE VERY SAME NUMBER THE CONTROLLER KEEPS */
const LIMIT = 10


/* Widget History */
class History extends Component {

    constructor() {
        super()

        this.state = { visible: false, ...EMPTY }
    }

    /* Open */
    open = () => {

        /* Open Modal */
        this.setState({ visible: true, ...EMPTY })

        /* Load Action */
        this.load()
    }

    /* Close */
    close = () => this.setState({ visible: false, ...EMPTY })


    /* Load Action */
    load = (page = 1, reload = false) => {

        /* Set Page */
        this.setState({ page })

        /* Reload */
        if (reload) {
            this.setState({ status: "loading", data: [] })
        }

        /* Load History */
        history(page).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: parseInt(utils.checkValue(response.data.count, 0)) })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })
    }


    /* DEVICE OF A ROW — THE COLUMN KEEPS A JSON OBJECT, ONLY ITS VALUES ARE WORTH A LINE */
    device = (json) => {

        try {

            /* Fields */
            const data = JSON.parse(json)

            /* Send Result */
            return Object.values(data).filter((item) => item && typeof item !== "object").join(" · ")

        }
        catch {
            return ""
        }
    }


    /* Draw Element */
    _element = (item, index) => {

        /* Fields */
        const mobile = String(item.type).toLowerCase() === "mobile"
        const place = [item.country, item.city].filter((value) => value).join(", ")
        const device = this.device(item.device)

        return (
            <div className={`profile--session ${item.current ? "current" : ""}`} key={`${index}`}>

                <div className={`profile--session-icon ${mobile ? "mobile" : ""}`}>
                    {mobile ? <PhoneIcon size={17} /> : <MonitorIcon size={17} />}
                </div>

                <div className="profile--session-text">

                    <div className="profile--session-top">

                        <span className="profile--session-browser">{utils.checkValue(item.browser, "—")}</span>

                        {item.current && <span className="profile--session-tag current">{t("profile.thisDevice")}</span>}

                        {item.result !== "success" && (
                            <span className={`profile--session-tag ${item.result === "password" ? "warning" : "danger"}`}>
                                {item.result === "password" ? t("profile.wrongPassword") : t("profile.failed")}
                            </span>
                        )}

                    </div>

                    {device !== "" && <div className="profile--session-device">{device}</div>}

                    <div className="profile--session-bottom">

                        <span className="profile--session-ip">{utils.checkValue(item.ip, "—")}</span>

                        {place !== "" && (
                            <span className="profile--session-place">
                                <PinIcon size={12} />
                                {place}
                            </span>
                        )}

                    </div>

                </div>

                <div className="profile--session-date">
                    <b>{moment(item.updatedAt).format("HH:mm")}</b>
                    <span>{moment(item.updatedAt).format("D MMM YYYY")}</span>
                </div>

            </div>
        )
    }


    /* Draw Body */
    _body = () => {

        /* Fields */
        const { status, data, page, count } = this.state

        /* Layout */
        if (status !== "ok") {
            return (
                <div className="profile--layout">
                    <Layout status={status} reload={() => this.load(1, true)} />
                </div>
            )
        }

        /* Empty */
        if (data.length === 0) {
            return (
                <div className="profile--layout">
                    <div className="profile--empty">
                        <ClockIcon size={34} />
                        <p>{t("profile.noHistory")}</p>
                    </div>
                </div>
            )
        }

        return (
            <div className="profile--body list">

                <div className="profile--sessions">
                    {data.map((item, index) => this._element(item, index))}
                </div>

                {count > LIMIT && <Pagination size={LIMIT} page={page} total={count} onPageChange={(value) => this.load(value)} />}

            </div>
        )
    }


    render = () => {

        /* Fields */
        const { visible, count } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="profile--modal wide"
                overlayClassName="profile--overlay"
                closeTimeoutMS={220}
            >

                <div className="profile--header">

                    <div className="profile--header-icon"><ClockIcon size={17} /></div>

                    <div className="profile--header-text">
                        <h2>{t("profile.historyTitle")}</h2>
                        <span>{count > 0 ? `${count} ${t("profile.records")}` : t("profile.historySubtitle")}</span>
                    </div>

                    <div onClick={() => this.close()} className="profile--close">
                        <CloseIcon size={13} />
                    </div>

                </div>

                {/* Draw Body */}
                {this._body()}

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(History)
